import React from "react";
import * as dc from "dc";
import {format} from 'd3';
import * as reductio from 'reductio';
import crossfilter from 'crossfilter2';

import { TotalTemplate } from "./totalTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    const myChart = dc.numberDisplay(divRef);
    
  
    // const taechertDimension =  ndx.dimension(function (d) {
    //     return d.teacher;
    // });
    
    const dimension = ndx.dimension(function (d) {
      return d;
    });
    
    const UniqueStudentsGroup = dimension
      .group()
      .reduce(
        function (p, v) {
            if(v.student in p.students){
              p.students[v.student] += 1
            }
            else{
                p.students[v.student] = 1;
                p.student_count++;
            }
            return p;
        },

        function (p, v) {
          if(v.student in p.students){
            p.students[v.student] -= 1
          }
            if(p.students[v.student] === 0){
                delete p.students[v.student];
                p.student_count--;
            }
            return p;
        },

        function () {
          return {
            students: {},
            student_count: 0
          }
        }
      )
    
  myChart
    .formatNumber(format(",d"))
    .dimension(dimension)
    .group(UniqueStudentsGroup)
    .valueAccessor(function (p) {
       return p.value.student_count ;
     })
    .transitionDuration(800)


    return myChart
}

export class TotalStudents extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TotalTemplate chartFunction={barChartFunc} title={this.props.title}
        dim={this.props.dim} type={this.props.type} />

    );
  }
}
